import React from 'react';
import { Grid } from '@material-ui/core';

import useLoginPage from './useLoginPage';
import LoginCard from './login_card/LoginCard';
import GoToCreateAccountPage from './GoToCreateAccountPage';

const LoginPage = () => {
  const {
    loginForm,
    setLoginForm,
    submit,
    loginErrors,
    isSubmiting,
    hasFinished,
    hasVerifiedEmail,
    exitPage,
  } = useLoginPage();

  return (
    <Grid container justify="center">
      <Grid item xs={8} sm={6} md={4}>
        <Grid item container direction="column">
          <Grid item container justify="center">
            <LoginCard
              loginForm={loginForm}
              setLoginForm={setLoginForm}
              onSubmitButtonPressed={submit}
              loginErrors={loginErrors}
              isSubmiting={isSubmiting}
              hasFinished={hasFinished}
              hasVerifiedEmail={hasVerifiedEmail}
              exitPage={exitPage}
            ></LoginCard>
          </Grid>

          <Grid item container style={{ marginTop: 48 }}>
            <GoToCreateAccountPage></GoToCreateAccountPage>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
